
class Buttons{

	constructor() {

		resizeCallbacks.push(this);
		this.splitHoverText();

	}

	splitHoverText(){
		let underlineHoverLink = document.querySelectorAll('.underline-hover-link');
		this.splitedElements = [];
		underlineHoverLink.forEach( (link) => {
			let splitedElement = new SplitText(link, {
				type: "lines",
				linesClass: "underline-hover-link-lines"
			});
			this.splitedElements.push( splitedElement );
		});
	}

	resize(){

		this.splitedElements.forEach( (el)  => {
			el.revert();
		});
		this.splitHoverText();

	}

}